import { render } from "./_footer.vue?vue&type=template&id=2a0ed90f"
const script = {}
script.render = render

export default script